import type { Product } from '@/lib/types/Product'
import { loadProduct } from '@/lib/productLoader'

export async function loadPdpUpsellRecommendations(
  customerId: string | undefined,
  context: string[],
): Promise<Product[]> {
  const products = await getProductRecommendations(customerId, context)
  return await Promise.all(
    products.map((p) => loadProduct(p.handle)).slice(0, 5),
  )
}

async function getProductRecommendations(
  customerId: string | undefined,
  context: string[],
): Promise<{ handle: string }[]> {
  const qs = new URLSearchParams()
  if (customerId) qs.append('customer_id', customerId)
  for (const c of context) qs.append('context', c)
  const res = await fetch(
    `https://api.bowercollective.com/recommendations/related?${qs.toString()}`,
  )
  const recs = await res.json()
  return recs
}

export async function loadCartUpsellRecommendations(
  customerId: string | undefined,
  context: string[],
): Promise<Product[]> {
  const products = await getCartRecommendations(customerId, context)
  return await Promise.all(
    products.map((p) => loadProduct(p.handle)).slice(0, 3),
  )
}

async function getCartRecommendations(
  customerId: string | undefined,
  context: string[],
): Promise<{ handle: string }[]> {
  const qs = new URLSearchParams()
  if (customerId) qs.append('customer_id', customerId)
  for (const c of context) qs.append('context', c)
  const res = await fetch(
    `https://api.bowercollective.com/recommendations/dispenser_first?${qs.toString()}`,
  )
  const recs = await res.json()
  return recs
}
